// src/components/NotFound.js
import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="uk-container  uk-text-center  " style={{ padding: '50px' , paddingTop:'280px' }}>
      <h1 className="uk-heading-large  uk-light ">Page Unavailable Temporarily</h1>
      <p className="uk-text-lead uk-light ">Sorry, the page you are looking for is under maintenance.</p>
      <Link to="/" className="uk-button uk-button-primary uk-margin-top">
        Go Back to Home
      </Link>
    </div>
  );
};

export default NotFound;